/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Ovid_DescriptionInputs */



/**
* | output |
* | --- |
* | "Offshore Vessel Inspection Database (OVID) inspections for offshore support vessels." |
*
* @param {Service_Ovid_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_ovid_description = /** @type {((inputs?: Service_Ovid_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Ovid_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("针对海工支持船的海上船舶检查数据库（OVID）检查。")
	return /** @type {LocalizedString} */ ("Offshore Vessel Inspection Database (OVID) inspections for offshore support vessels.")
});